module.exports = __webpack_public_path__ + "media/images/icons/search-1792b2c94e1e92176e2826ff5f3a891e.svg";